// Shell shared by the game reports: controls, color legend and the offscreen
// node the PDF is printed from

import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import ColorLegend from './ColorLegend';
import { fadeColorLegend } from '../utils/colorLegend';
import './GameReport.scss';

export default function GameReport({
  id,
  colorLegend,
  documentTitle,
  pdf,
  children,
}) {
  const pdfRef = useRef(null);

  const onPrintPDF = useReactToPrint({
    contentRef: pdfRef,
    documentTitle,
  });

  return (
    <div className='game-report'>
      <div className='legend-float-host sticky-top'>
        <button className='small bw fa-pdf icon' onClick={onPrintPDF}>
          Print/Save as PDF
        </button>
        <ColorLegend id={id} colorLegend={fadeColorLegend(colorLegend)} />
      </div>
      {children}
      <div ref={pdfRef} className='game-report-pdf-wrap'>
        {pdf}
      </div>
    </div>
  );
}
